
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generations-in-the-wild-24",
      function () {
        return require("private-next-pages/generations-in-the-wild-24.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generations-in-the-wild-24"])
      });
    }
  